// changePasswordForm.js
import { rerenderValidationNew, validateField, validateForm } from "../utils/validation";
import { trans } from "../i18n/i18n";

// Constants
const CHANGE_PASSWORD_FORM_SELECTOR = "#change-password-form";

/**
 * Initializes change password form validation.
 */
export function initChangePasswordFormValidation() {
    const form = document.querySelector(CHANGE_PASSWORD_FORM_SELECTOR);
    if (!form) return;

    form.addEventListener("input", handleFormInput);
    form.addEventListener("change", handleFormInput);
}

/**
 * Validates fields on input or change events.
 *
 * @param {Event} e
 */
function handleFormInput(e) {
    const inputEl = e.target;
    const fieldName = inputEl.name;

    const allErrors = validateField(e.currentTarget, inputEl, getChangePasswordValidationRules(), getWhitelistChangePassword());
    const fieldErrors = allErrors?.[fieldName] || [];
    rerenderValidationNew(inputEl, fieldErrors);
}

/**
 * Defines validation rules for the change password form.
 *
 * @returns {Object}
 */
export function getChangePasswordValidationRules() {
    const rules = {
        password: {
            presence: true,
            length: { minimum: 8 }
        },
        password_confirmation: {
            presence: true,
            equality: { attribute: "password", message: trans("Passwords do not match") }
        }
    };

    const currentPasswordField = document.getElementById('current-password');
    if (currentPasswordField) {
        rules.password_current = {
            presence: true,
            length: { minimum: 8 }
        };
    }

    return rules;
}

/**
 * Defines the whitelist of fields to validate.
 *
 * @returns {Object}
 */
export function getWhitelistChangePassword() {
    const list = {
        password: true,
        password_confirmation: true
    };

    const currentPasswordField = document.getElementById('current-password');
    if (currentPasswordField) {
        list.password_current = true;
    }

    return list;
}
